<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/U5nYqU/Images/Cover.jpg?1697026214044" alt="This image is the cover for the book Their Unexpected Family"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Their Unexpected Family
      </h1>
      <p class="bookDescription body article font2">
        <p>SERVICE WITH A SMILE…Well, readers, Juliet Rivera, our favorite waitress at the Hitching Post, has finally followed her doctor's orders and is taking some much-needed time off before her little bundle of joy arrives. And she's got company—word is that reporter Mark Anderson has been keeping a close eye on our gal…Loyal readers, this prospector can personally vouch for the sparks that have been flying between Juliet and Mark! Yet the sexy native son has been gone a long time—and in spite of doting on Juliet, he doesn't seem too eager to hang around town and face his own troubled past. Will this investigative Romeo put his demons to rest and find love with the beautiful mom-to-be?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judy Duarte
      </h2>
      
      <p class="authorDescription body article">Twenty-four years ago,<I> USA Today </I>bestselling author Judy Duarte couldn&rsquo;t shake the dream of creating a story of her own. That dream became a reality in 2002, when Harlequin released the first of more than sixty books. Judy&#39;s stories have touched the hearts of readers around the world. A two-time Rita finalist, Judy&#39;s books won two Maggies and a National Reader&rsquo;s Choice Award. You can contact her at <a href="http://www.judyduarte.com">www.judyduarte.com</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2bb71754